import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=043111e4&scoped=true&"
import script from "./Pagination.vue?vue&type=script&setup=true&lang=js&"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=043111e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043111e4",
  null
  
)

export default component.exports